import * as api from 'commons/js/api'

import { navigateTo } from 'commons/js/services/navigate'
import { takeLatest } from 'commons/js/util/promiseUtils'
import Routes from 'commons/js/routes/routes'

export const getBookingAvailability = takeLatest((params) => {
    return api.getBookingAvailability(params)
})

export function navigateToBookingProcess (product, filter) {
    const url = Routes.vehicleInspectionBookingProcessPath({
        station_id: product.id_vehicle_inspection_station,
        station_product_id: product.id_vehicle_inspection_product,
        vehicle_filter: filter.value,
    })

    navigateTo(url)
}

export const getProductByVehicleAndStation = takeLatest((params) => {
    return api.requestVehicleInspectionProducts(params)
})
